const Report=() => {
    return(
        <div>
        <h2>보고서 등록</h2>
        </div>
    )
}

export default Report;